import styled from 'styled-components';

export const CaptchaFormStyled = styled.div`
    img {
        width: 100%;
    }
`;
